<template>
  <div class="asc-alert-icon-label--container">
    <asc-alert-icon
      class="asc-alert-label--icon"
      :status="status"
    ></asc-alert-icon>
    <template v-if="getValueTitle != ''">
      <asc-alert-label
        class="asc-alert-label--title"
        :value="getValueTitle"
        :color="getFontColor"
        :bold="isBold"
      ></asc-alert-label>
    </template>
  </div>
</template>

<script>
import { AscStatusPropsMixin } from '@/components/mixins'
import AscAlertIcon from './AscAlertIcon'
import AscAlertLabel from './AscAlertLabel'

export default {
  name: 'AscAlertIconLabel',

  components: {
    AscAlertIcon,
    AscAlertLabel,
  },

  mixins: [AscStatusPropsMixin],

  props: {
    value: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    colorIconOnly: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getValueTitle() {
      return `${this.value} ${this.title}`
    },

    getFontColor() {
      return !this.colorIconOnly ? this.getBgColor : ''
    },

    isBold() {
      return !this.colorIconOnly
    },
  },
}
</script>

<style lang="scss">
.asc-alert-icon-label--container {
  display: flex;

  & .asc-alert-label--title {
    flex: 1;
    min-width: 0;
    padding: 2px 0 0 8px;

    & .asc-alert-label {
      margin-left: 0;
    }
  }
}
</style>
